export const RULES_ROOT_STORE_PATH = 'rules/'
export const ACTIVE_PROJECT_STORE_PATH = `${RULES_ROOT_STORE_PATH}activeProjectModule/`
export const COMPONENT_EDITOR_STORE_PATH = `${RULES_ROOT_STORE_PATH}componentEditor/`
export const RULE_EDITOR_CONTEXT_STORE_PATH = `${COMPONENT_EDITOR_STORE_PATH}ruleEditorContext/`
